import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["url", "status", "testButton"]
  static values = { 
    clientId: String,
    saveUrl: String,
    testUrl: String
  }

  connect() {
    console.log("Slack config controller connected")
  }

  async save() {
    const url = this.urlTarget.value.trim()
    
    if (!url) {
      this.showStatus("Please enter a Slack webhook URL", "error")
      return
    }

    // Validate URL format
    if (!this.isValidWebhookUrl(url)) {
      this.showStatus("Please enter a valid Slack webhook URL (should start with https://hooks.slack.com/)", "error")
      return
    }

    try {
      const response = await fetch(this.saveUrlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({
          client: {
            slack_webhook_url: url
          }
        })
      })

      if (response.ok) {
        this.showStatus("Slack webhook URL saved successfully", "success")
        // Update the UI to show that Slack is configured
        this.updateSlackStatus(true)
      } else {
        const error = await response.json()
        this.showStatus(error.error || "Failed to save Slack webhook URL", "error")
      }
    } catch (error) {
      console.error("Error saving Slack webhook URL:", error)
      this.showStatus("Failed to save Slack webhook URL", "error")
    }
  }

  async test() {
    const url = this.urlTarget.value.trim()
    
    if (!url) {
      this.showStatus("Please enter a Slack webhook URL first", "error")
      return
    }

    this.testButtonTarget.disabled = true
    this.testButtonTarget.textContent = "Testing..."

    try {
      const response = await fetch(this.testUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({
          webhook_url: url
        })
      })

      if (response.ok) {
        this.showStatus("Test message sent successfully! Check your Slack channel.", "success")
      } else {
        const error = await response.json()
        this.showStatus(error.message || "Failed to send test message", "error")
      }
    } catch (error) {
      console.error("Error testing Slack webhook:", error)
      this.showStatus("Failed to send test message", "error")
    } finally {
      this.testButtonTarget.disabled = false
      this.testButtonTarget.textContent = "Test"
    }
  }

  showStatus(message, type) {
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = message
      this.statusTarget.className = `text-xs ${type === "success" ? "text-theme-success" : "text-theme-error"}`
      this.statusTarget.classList.remove("hidden")
      
      // Hide after 5 seconds
      setTimeout(() => {
        this.statusTarget.classList.add("hidden")
      }, 5000)
    }
  }

  isValidWebhookUrl(url) {
    try {
      const urlObj = new URL(url)
      return urlObj.protocol === "https:" && 
             urlObj.hostname === "hooks.slack.com" && 
             urlObj.pathname.startsWith("/services/")
    } catch {
      return false
    }
  }

  updateSlackStatus(configured) {
    // Find and update the Slack status indicator
    const statusElement = document.querySelector('[data-slack-status]')
    if (statusElement) {
      if (configured) {
        statusElement.innerHTML = '<span class="text-theme-success">✓ Slack is configured and ready</span>'
      } else {
        statusElement.innerHTML = 'Enter a valid Slack webhook URL to enable Slack notifications'
      }
    }
  }
}
